export const handleZendeskRedirect = (token: string, redirectURL: string) => {
    const jwt = token;

    // Create form element
    const form = document.createElement("form");
    form.setAttribute("target", "_blank");
    form.setAttribute("action", "https://betterspace.zendesk.com/access/jwt");
    form.setAttribute("method", "post");

    // Create input element for JWT
    const jwtInput = document.createElement("input");
    jwtInput.setAttribute("type", "hidden");
    jwtInput.setAttribute("name", "jwt");
    jwtInput.setAttribute("value", jwt);
    form.appendChild(jwtInput);

    // Create input element for return_to
    const returnToInput = document.createElement("input");
    returnToInput.setAttribute("type", "hidden");
    returnToInput.setAttribute("name", "return_to");
    returnToInput.setAttribute("value", redirectURL);
    form.appendChild(returnToInput);

    // Append form to document body
    document.body.appendChild(form);

    // Submit the form
    form.submit();

    document.body.removeChild(form);
};
